import {
    Typography,
    Button,
    Grid
} from '@mui/material';
import { Plus } from 'mdi-material-ui';  
import { useState } from 'react'
import DialogPoint from 'src/views/point/DialogPoint'
import TablePointUse from 'src/views/point/TablePointUse'
import Page from '../../components/Page'
import PageHeader from '../../components/page-header'
import BoxWrapper from '../../styles/BoxWrapper'

const PointList = () => {
    const [reload, setReload] = useState(0);
    const [show, setShow] = useState(false);

    return (
        <Page title="Point">
            <Grid container spacing={6}>
                <PageHeader
                    title={
                    <Typography variant='h5' color='#666CFF'>
                        포인트 사용내역
                    </Typography>
                    }
                    subtitle={
                    <Typography variant='body2'>
                        포인트를 통해 사용자의 지속적인 상품 구매를 유도하세요
                    </Typography>
                    }
                />
                <BoxWrapper>
                    <Button variant='contained' startIcon={<Plus />} onClick={() => {setShow(true)}} >수동 발행</Button>
                </BoxWrapper>
                <DialogPoint show={show} setShow={setShow} setReload={setReload} />
                <Grid item xs={12}>        
                    <TablePointUse reload={reload} setReload={setReload} />
                </Grid>
            </Grid>
        </Page>
    )
}

export default PointList